import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Head from 'next/head'
import axios from 'axios';

const Navbar = dynamic(() => import('../components/Layouts/Navbar', { ssr: false }));
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../components/Layouts/Breadcrumb', { ssr: false }));
const ReportCategory = dynamic(() => import('../components/Sitemap/ReportCategory'), { ssr: false })
const Infographics = dynamic(() => import('../components/Sitemap/Infographics'))
const StaticPages = dynamic(() => import('../components/Sitemap/StaticPages'))
const Newsletter = dynamic(() => import('../components/Sitemap/NewsletterWhitepaper'), { ssr: false })

const BlogThArea = dynamic(() => import('../components/Sitemap/BlogThArea'), { ssr: false })
const BlogCategory = dynamic(() => import('../components/Sitemap/BlogCategory'), { ssr: false })
const BlogIndustry = dynamic(() => import('../components/Sitemap/BlogIndustry'), { ssr: false })
const ConferenceSitemap = dynamic(() => import('../components/Sitemap/Conference'), { ssr: false })
const BlogPage = dynamic(() => import('../components/Sitemap/BlogPage'), { ssr: false })

const Sitemap = () => {

  return (
    <>
      <Navbar />
      <div className='mt-65 mb-20'>
        <Breadcrumb />
        <ReportCategory />
        <Infographics />
        <ConferenceSitemap />
        <StaticPages />
        <Newsletter />
        <BlogThArea />
        <BlogCategory />
        <BlogIndustry />
        <BlogPage />
      </div>
      <Footer />
    </>
  )
}

Sitemap.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
      const response = await axios.get(process.env.API_URL + '/meta' + slugData);
      return {
          title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}

export default Sitemap;

